"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.NpxBuildDriverImpl = exports.NpxBuildDriver = void 0;
const tslib_1 = require("tslib");
const baseBuildDriver_1 = require("./baseBuildDriver");
const typedi_1 = require("typedi");
const baseBuildStepDriver_1 = require("./baseBuildStepDriver");
const hooks_1 = require("@feathersjs/hooks");
const addStartAndEndTelemetry_1 = require("../middleware/addStartAndEndTelemetry");
const commonConstant_1 = require("../../constant/commonConstant");
const localizeUtils_1 = require("../../../common/localizeUtils");
const ACTION_NAME = "cli/runNpxCommand";
let NpxBuildDriver = class NpxBuildDriver extends baseBuildStepDriver_1.BaseBuildStepDriver {
    constructor() {
        super(...arguments);
        this.description = localizeUtils_1.getLocalizedString("driver.script.npxDescription");
    }
    execute(args, ctx) {
        return super.execute(args, ctx);
    }
    getImpl(args, context) {
        return new NpxBuildDriverImpl(args, context, "https://aka.ms/teamsfx-actions/cli-run-npx-command");
    }
};
tslib_1.__decorate([
    hooks_1.hooks([addStartAndEndTelemetry_1.addStartAndEndTelemetry(ACTION_NAME, commonConstant_1.TelemetryConstant.SCRIPT_COMPONENT)]),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], NpxBuildDriver.prototype, "execute", null);
NpxBuildDriver = tslib_1.__decorate([
    typedi_1.Service(ACTION_NAME)
], NpxBuildDriver);
exports.NpxBuildDriver = NpxBuildDriver;
class NpxBuildDriverImpl extends baseBuildDriver_1.BaseBuildDriver {
    constructor() {
        super(...arguments);
        this.buildPrefix = "npx";
    }
}
exports.NpxBuildDriverImpl = NpxBuildDriverImpl;
//# sourceMappingURL=npxBuildDriver.js.map